import { BAFTA_IMPACT_FUND_SLUG, getPhoenixUrl, User } from "@ecologi/shared";
import { TuftyButton } from "../../Button/TuftyButton";

type Props = {
  isOwnProfile: boolean;
  isBulkParent?: boolean;
  user?: User | null;
  username?: string;
};

const buildImpactShopUrl = (
  path: string,
  username?: string,
  isOwnProfile?: boolean
): string => {
  const params = new URLSearchParams({
    utm_source: "Profiles",
    utm_medium: isOwnProfile ? "BuyMoreImpactCTA" : "FundImpactCTA",
    ...(username ? { utm_content: username } : {}),
  });
  return `${path}?${params.toString()}`;
};

export const BuyMoreImpactButton = ({
  isOwnProfile,
  isBulkParent,
  username,
}: Props) => {
  return (
    <TuftyButton
      primary
      extra={{
        style: {
          display: "block",
          margin: "15px auto 0",
        },
      }}
      onClick={(e) => {
        e.preventDefault();
        if (e.currentTarget instanceof HTMLElement) {
          e.currentTarget.blur();
        }

        const phoenixUrl = getPhoenixUrl(process.env.NEXT_PUBLIC_DEPLOYMENT);
        const marketplacePath = isBulkParent
          ? `${phoenixUrl}/impact-funds/${BAFTA_IMPACT_FUND_SLUG}`
          : `${phoenixUrl}/impact-marketplace`;

        window.open(
          buildImpactShopUrl(marketplacePath, username, isOwnProfile),
          "_blank",
          "noopener,noreferrer"
        );
      }}
      text={isOwnProfile ? "Buy more impact" : "Fund impact"}
    />
  );
};
